export default __webpack_public_path__ + "static/media/DarkPhone.6eedb288.svg";